import { Analytics } from "@/analytics";
import { TrackableEvent } from "@/analytics/TrackableEvents";
import { useProducersStore } from "@/stores/producers";

/**
 * Composable for analytics tracking
 * Fires events to analytics strategies configured for the default producer and optionally for specific producers
 */
export function useAnalytics() {
  /**
   * Fires an event for possible list of targets composed by the default project's strategies and any number of
   * producer-based strategies
   *
   * @param event enumeration representing one of the many event types supported by the project
   * @param params map of parameters that should be passed to the fired event
   */
  function collect(event: TrackableEvent, { producer_id = undefined, params }: { producer_id?: string; params: Record<string, unknown> }) {
    console.log(`[Analytics] - Collecting event ${TrackableEvent[event]} with params:`, params);

    const producersStore = useProducersStore();
    const base = producersStore.default;

    const targets = [
      base,
    ];

    if (producer_id != null) {
      const producer = producersStore.producers.find(p => p.id.includes(producer_id));
      if (producer !== undefined) targets.push(producer);
    }

    targets.forEach(
      t => t.analytics?.forEach(
        a => Analytics.make(a).send(event, params),
      ),
    );
  }

  return {
    collect,
  };
}
